import { render, staticRenderFns } from "./goldAction.vue?vue&type=template&id=1b8298ee"
import script from "./goldAction.vue?vue&type=script&lang=js"
export * from "./goldAction.vue?vue&type=script&lang=js"
import style0 from "./goldAction.vue?vue&type=style&index=0&id=1b8298ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports